import React, { useEffect, useRef, useState } from "react";
import {
  AddFlex,
  CreateInstaAutomationInput,
  CustomInput,
  CustomInputLabel,
  CustomText,
} from "../../reusableStyles";
import { primaryActionColor, primaryActionColorLight } from "../../constants";
import { Button, Radio, Tag } from "antd";
import {
  capitalizeFirstLetter,
  isArrayNullOrUndefined,
  isNullOrUndefined,
  isStringNullOrUndefined,
} from "../../utils";

const ExampleKeywords = ["Price", "Interested", "Link"];

function InstaCommentToDMAutomationKeywords({
  isEdit,
  automationData,
  disabled,
  handleCheckCommentAutomationValidations,
  errors,
  stage,
  setErrors,
  setStage,
  isCampagin,
  handleSetAutomationData,
}) {
  const [inputValue, setInputValue] = useState("");
  const [chips, setChips] = useState(automationData.keywords?.keywords || []);
  const inputRef = useRef(null);
  const [keywords, setKeywords] = useState(automationData.keywords || {});

  const handleInputChange = (e) => {
    const value = e.target.value;

    // If user enters a comma, create a new chip
    if (value.endsWith(",")) {
      const newWord = value.slice(0, -1).trim();
      if (newWord) {
        setChips([...chips, newWord]);
        setInputValue("");
      }
    } else {
      setInputValue(value);
    }
  };

  const handleRemoveAdvancedReplyForWord = (chip) => {
    try {
      if (automationData?.dmMessage?.isAdvanced) {
        const dmMessage = { ...automationData.dmMessage };
        if (dmMessage.data[chip]) delete dmMessage.data[chip];
        handleSetAutomationData("dmMessage", dmMessage);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyDown = (e) => {
    // Handle backspace
    if (e.key === "Backspace" && inputValue === "" && chips.length > 0) {
      e.preventDefault();
      const chip = chips[chips.length - 1];
      const newChips = chips.slice(0, -1);
      setChips(newChips);
      handleRemoveAdvancedReplyForWord(chip.toLowerCase());
    }
  };

  useEffect(() => {
    if (isNullOrUndefined(inputValue.trim()) && isArrayNullOrUndefined(chips))
      return;

    const allKeywords = [...chips];
    if (inputValue.trim()) {
      allKeywords.push(inputValue.trim());
    }
    handleSetAutomationData("keywords", {
      ...keywords,
      keywords: allKeywords
        ?.filter((word) => word.trim().length > 0)
        ?.map((word) => word.trim()),
    });
  }, [chips, inputValue, keywords]);

  return (
    <AddFlex flexDirection="column" gap="10px">
      <AddFlex flexDirection="column">
        <CustomText fontSize="20px" color="black" fontWeight="700">
          And the comment has
        </CustomText>
        {errors.keywords && (
          <CustomText color="red" fontSize="14px">
            {errors.keywords}
          </CustomText>
        )}
      </AddFlex>
      <AddFlex
        flexDirection="column"
        borderRadius="5px"
        backgroundColor="#f6f7f9"
        gap="10px"
        padding="10px"
        onClick={() => {
          if (disabled) return;
          setKeywords((prev) => ({ ...prev, type: "specific" }));
        }}
      >
        <AddFlex gap="10px" alignItems="center">
          <Radio
            disabled={disabled}
            type="radio"
            checked={keywords.type === "specific"}
          />
          <CustomInputLabel
            style={{ margin: 0, fontWeight: "500", fontSize: "15px" }}
            color="black"
          >
            A Specific word or words
          </CustomInputLabel>
        </AddFlex>

        {keywords.type === "specific" && (
          <>
            <div className="bg-white rounded-lg border border-gray-200 p-3">
              <div className="flex flex-wrap gap-2">
                {chips.map((chip, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-blue-100 text-blue-600 rounded-full text-sm"
                  >
                    {chip}
                  </span>
                ))}
                <input
                  ref={inputRef}
                  type="text"
                  disabled={disabled}
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  onKeyDownCapture={() => {
                    handleRemoveAdvancedReplyForWord(inputValue.toLowerCase());
                  }}
                  className={`flex-grow outline-none min-w-[120px]`}
                  placeholder={
                    chips.length === 0 ? "Price, Link Dm, Interested" : ""
                  }
                  style={disabled ? { display: "none" } : { display: "block" }}
                />
              </div>
            </div>
            {/* <CustomInput
              value={keywords.keywords?.join(",")}
              placeholder={"| Enter your keywords here"}
              footerText={"Use commas to separate words"}
              disabled={disabled}
              onChange={(text) => {
                setKeywords((prev) => ({
                  ...prev,
                  keywords: text.split(","),
                }));
              }}
            /> */}
            {/* <AddFlex wrap="wrap" marginBottom="10px" gap="5px">
              {automationData.keywords.keywords?.map((word, index) => (
                <Tag color="blue" key={index} style={{ margin: 0 }}>
                  {word}
                </Tag>
              ))}
            </AddFlex> */}

            <AddFlex gap="5px" alignItems="center">
              <CustomText fontSize="14px">For example :</CustomText>
              {ExampleKeywords.map((word) => (
                <AddFlex
                  padding="3px 10px"
                  justify="center"
                  alignItems="center"
                  border={`1px solid ${primaryActionColor}`}
                  backgroundColor={primaryActionColorLight}
                  color={primaryActionColor}
                  onClick={() => {
                    if (disabled) return;
                    setChips([word]);
                  }}
                  style={{
                    fontSize: "14px",
                    borderRadius: "25px",
                    width: "max-content",
                    cursor: "pointer",
                  }}
                >
                  {word}
                </AddFlex>
              ))}
            </AddFlex>
            <CustomText color="black" fontSize="14px" fontWeight="500">
              NOTE: Use commas to separate words!
            </CustomText>
          </>
        )}
      </AddFlex>
      <AddFlex
        flexDirection="column"
        borderRadius="5px"
        backgroundColor="#f6f7f9"
        padding="10px"
        onClick={() => {
          if (disabled) return;
          setChips([]);
          setKeywords((prev) => ({ ...prev, type: "any", keywords: [] }));
        }}
      >
        <AddFlex gap="10px" alignItems="center">
          <Radio
            disabled={disabled}
            type="radio"
            checked={keywords.type === "any"}
          />
          <CustomInputLabel
            style={{ margin: 0, fontWeight: "500", fontSize: "15px" }}
            color="black"
          >
            Any word
          </CustomInputLabel>
        </AddFlex>
      </AddFlex>
      {!isEdit && stage <= 2 && (
        <Button
          onClick={() => {
            const errors = handleCheckCommentAutomationValidations(
              automationData,
              2,
              isCampagin
            );
            console.log(errors);
            if (Object.keys(errors).length === 0) {
              setStage(3);
              setErrors(errors);
            } else {
              setErrors(errors);
            }
          }}
          variant="primary"
          style={{
            width: "max-content",
            color: "white",
            backgroundColor: primaryActionColor,
          }}
        >
          Next
        </Button>
      )}
    </AddFlex>
  );
}

export default InstaCommentToDMAutomationKeywords;
